import { cn } from '@/lib/utils';

interface SectionProps extends React.HTMLAttributes<HTMLElement> {
  title?: string;
  subtitle?: string;
  /** `plain` : pas de classe de fond (utiliser `className` pour le fond exact, ex. `bg-background`) */
  variant?: 'default' | 'dark' | 'gradient' | 'light' | 'navy' | 'navyLight' | 'plain';
}

export function Section({
  children,
  className,
  title,
  subtitle,
  variant = 'default',
  ...props
}: SectionProps) {
  const variants = {
    default: 'bg-section-navy-light',
    dark: 'bg-section-navy',
    gradient: 'bg-section-navy-light',
    light: 'bg-white',
    navy: 'bg-section-navy',
    navyLight: 'bg-section-navy-light',
    plain: ''
  };

  const isNavyDark = variant === 'dark' || variant === 'navy';

  return (
    <section
      className={cn('py-20 px-4', variants[variant], className)}
      {...props}
    >
      <div className="max-w-7xl mx-auto">
        {(title || subtitle) && (
          <div className="text-center mb-16">
            {title && (
              <h2
                className={cn(
                  'text-4xl md:text-5xl font-bold leading-normal mb-4',
                  isNavyDark
                    ? 'text-white'
                    : 'bg-gradient-to-r from-accent via-secondary to-primary bg-clip-text text-transparent'
                )}
              >
                {title}
              </h2>
            )}
            {subtitle && (
              <p
                className={cn(
                  'text-xl max-w-2xl mx-auto',
                  isNavyDark ? 'text-white/90' : 'text-foreground'
                )}
              >
                {subtitle}
              </p>
            )}
          </div>
        )}
        {children}
      </div>
    </section>
  );
}
